import React, { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useLocation } from 'react-router';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import FileUploader from '../../Shared/Components/FileUploader';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { getStoredAuthToken } from '../../Shared/utils/authToken';
import { baseApiUrl, serverErrorHandler } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const validationSchema = Yup.object({
  name: Yup.string().nullable().max(200),
  logo: Yup.string().nullable(),
  favicon: Yup.string().nullable(),
  e_namad: Yup.string().nullable(),
});

const General = () => {
  const context = useContext(EventContext);
  const { search } = useLocation();
  const [serverErrors, setServerErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [formSubmitLoading, setSubmitFormLoading] = useState(false);
  const [logo, setLogo] = useState('');
  const [favIcon, setFavIcon] = useState('');

  useEffect(() => {
    getSetting();
  }, [search]);

  const getSetting = async () => {
    setLoading(true);
    await useApi.get(
      '/setting',
      {},
      (res) => {
        const { data } = res;
        context.setting = data?.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('خطا در دیافت اطلاعات از سرور');
      },
    );
  };

  const handleSubmit = async (values) => {
    setSubmitFormLoading(true);
    let logoPath = context?.setting?.logo?.logo ?? '';
    if (logo.length > 0) {
      let photoId = logo?.[0]?.serverId;
      let logoUpload = JSON?.parse(photoId);
      logoPath = logoUpload?.data?.path;
    }
    let faviconPath = context?.setting?.logo?.favicon ?? '';
    if (favIcon.length > 0) {
      let photoId = favIcon?.[0]?.serverId;
      let faviconUpload = JSON?.parse(photoId);
      faviconPath = faviconUpload?.data?.path;
    }
    values['logo'] = { logo: logoPath, favicon: faviconPath };

    await useApi.post(
      '/setting',
      values,
      (res) => {
        success('تنظیمات با موفقیت ذخیره شد');
        setSubmitFormLoading(false);
        window.location.reload();
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`تنظیمات به علت خطا ذخیره نشد`);
        }
        setSubmitFormLoading(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            تنظیمات عمومی
          </h1>
        </div>
      </div>
      <div className='px-6 bg-slate-300 dark:bg-dark-800 pt-8 rounded-tr-3xl min-h-screen py-3'>
        <Formik
          initialValues={{
            name: context?.setting?.name ?? '',
            logo: context?.setting?.logo?.logo ?? '',
            favicon: context?.setting?.logo?.favicon ?? '',
            e_namad: context?.setting?.e_namad ?? '',
          }}
          onSubmit={(values, { setSubmitting }) => {
            handleSubmit(values, setSubmitting);
          }}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>عنوان سایت</label>
                    <input
                      type='text'
                      name='name'
                      value={values.name}
                      onChange={handleChange}
                      className='form-control'
                    />
                    <ErrorMessage
                      error={
                        serverErrors?.name ? serverErrors?.name : errors.name
                      }
                    />
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>لوگو</label>
                    {context?.setting?.logo?.logo && (
                      <img
                        src={context?.setting?.logo?.logo ?? ''}
                        className='my-2 text-center mx-auto img-thumbnail'
                        style={{ width: '150px', height: '150px' }}
                        alt=''
                      />
                    )}
                    <div className='w-50'>
                      <FileUploader
                        files={logo}
                        setFiles={setLogo}
                        name='file'
                        roles={['image/jpeg', 'image/jpg', 'image/png']}
                        required={true}
                        allowMultiple={false}
                        maxFiles={1}
                        maxFileSize='1024KB'
                        serverUrl={`${baseApiUrl()}/upload/public/file`}
                        method='POST'
                        headers={{
                          Accept: 'application/json',
                          Authorization: getStoredAuthToken(),
                        }}
                      />
                      <ErrorMessage
                        error={
                          serverErrors?.logo ? serverErrors?.logo : errors.logo
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>آیکن</label>
                    {context?.setting?.logo?.favicon && (
                      <img
                        src={context?.setting?.logo?.favicon ?? ''}
                        className='my-2 text-center mx-auto img-thumbnail'
                        style={{ width: '150px', height: '150px' }}
                        alt=''
                      />
                    )}
                    <div className='w-50'>
                      <FileUploader
                        files={favIcon}
                        setFiles={setFavIcon}
                        name='file'
                        roles={['image/jpeg', 'image/jpg', 'image/png']}
                        required={true}
                        allowMultiple={false}
                        maxFiles={1}
                        maxFileSize='1024KB'
                        serverUrl={`${baseApiUrl()}/upload/public/file`}
                        method='POST'
                        headers={{
                          Accept: 'application/json',
                          Authorization: getStoredAuthToken(),
                        }}
                      />
                      <ErrorMessage
                        error={
                          serverErrors?.logo ? serverErrors?.logo : errors.logo
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>اینماد</label>
                    <textarea
                      name='e_namad'
                      value={values.e_namad}
                      onChange={handleChange}
                      className='form-control'
                    ></textarea>
                    <ErrorMessage
                      error={
                        serverErrors?.e_namad
                          ? serverErrors?.e_namad
                          : errors.e_namad
                      }
                    />
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group mt-4'>
                    {formSubmitLoading ? (
                      <button
                        className='btn btn-info mt-1'
                        type='button'
                        disabled={true}
                      >
                        <div
                          className='spinner-border spinner-border-sm text-white mb-1'
                          role='status'
                        ></div>
                      </button>
                    ) : (
                      <button className='btn btn-info mt-1' type='submit'>
                        ثبت
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Master>
  );
};

export default General;
